import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    background: {
      default: "#000000",
    },
    secondary: {
      main: "#F70083",
    },
    info: {
      main: "#ffffff",
    },
  },
  typography: {
    body2: {
      fontSize: 12,
    },
    body3: {
      fontSize: 10,
      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
      fontWeight: "400",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { color: "primary" },
              style: {
                backgroundColor: "black",
                color: "white",
              },
            },
          ],
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          '& .Mui-selected': {
            backgroundColor: '#F5F5F5!important',
          },
        }
      }
    },
  },
});

export default theme;
